import { glossaryEntry } from './glossary/index.js';

export const COLUMN_TYPES = ['int', 'decimal', 'percent', 'date', 'datetime', 'text', 'metric'];

export const NUMERIC_COLUMN_TYPES = ['int', 'decimal', 'percent', 'metric'];

export const COLUMN_FIELDS = [
  'key', 'label', 'type', 'infoKey', 'value', 'unit', 'numeric', 'sortable', 'sort', 'startDescending', 'screen', 'export', 'exportedAs', 'width',
  'description', 'decimals',
];

export const MAX_DECIMALS = 6;

export const METRIC_UNITS = ['count', 'pct', 'ratio', 'days'];

export const COLUMNS_SUFFIX = '_COLUMNS';

const KEY = /^[A-Za-z][A-Za-z0-9_.]*$/;

const textOf = (value) => (typeof value === 'string' ? value.trim() : '');

export const isColumnType = (type) => COLUMN_TYPES.indexOf(type) !== -1;

const fieldValue = (key) => (row) => (row && typeof row === 'object' ? row[key] : undefined);

export const defineColumn = (spec) => {
  const source = spec && typeof spec === 'object' ? spec : {};
  return Object.assign({}, source, {
    numeric: typeof source.numeric === 'boolean' ? source.numeric : NUMERIC_COLUMN_TYPES.indexOf(source.type) !== -1,
    sortable: source.sortable === true,
    screen: source.screen !== false,
    export: source.export !== false,
    value: typeof source.value === 'function' ? source.value : fieldValue(source.key),
  });
};

export const defineColumns = (specs) => (Array.isArray(specs) ? specs : []).map(defineColumn);

export const isColumnSpecList = (value) => Array.isArray(value) && value.length > 0
  && value.some((item) => !!item && typeof item === 'object' && isColumnType(item.type));

export const screenColumns = (specs) => (Array.isArray(specs) ? specs : []).filter((spec) => !!spec && spec.screen !== false);

export const exportColumns = (specs) => (Array.isArray(specs) ? specs : []).filter((spec) => !!spec && spec.export !== false);

export const columnByKey = (specs, key) => (Array.isArray(specs) ? specs : []).filter((spec) => !!spec && spec.key === key)[0] || null;

export const columnValue = (spec, row) => {
  if (!spec) return undefined;
  if (typeof spec.value === 'function') return spec.value(row);
  return fieldValue(spec.key)(row);
};

export const columnProblems = (specs) => {
  if (!Array.isArray(specs) || !specs.length) return ['lista de colunas vazia'];
  const problems = [];
  const keys = [];
  specs.forEach((spec, index) => {
    const name = spec && typeof spec.key === 'string' && spec.key ? spec.key : '#' + index;
    const add = (text) => problems.push(name + ': ' + text);
    if (!spec || typeof spec !== 'object') {
      add('coluna que não é objeto');
      return;
    }
    if (!KEY.test(textOf(spec.key))) add('key ausente ou inválida');
    else if (keys.indexOf(spec.key) !== -1) add('key repetida');
    else keys.push(spec.key);
    if (!textOf(spec.label)) add('sem label');
    if (!isColumnType(spec.type)) add('type fora de ' + COLUMN_TYPES.join(', '));
    if (!textOf(spec.infoKey)) add('sem infoKey');
    else if (!glossaryEntry(spec.infoKey)) add('infoKey sem entrada no glossário: ' + spec.infoKey);
    if (spec.value !== undefined && typeof spec.value !== 'function') add('value precisa ser função (row) => valor');
    if (spec.screen === false && spec.export === false) add('coluna nem na tela nem na exportação');
    if (spec.width !== undefined && !(typeof spec.width === 'number' && spec.width > 0)) add('width precisa ser número positivo');
    if (spec.unit !== undefined && (spec.type !== 'metric' || METRIC_UNITS.indexOf(spec.unit) === -1)) add('unit só vale para type metric: ' + METRIC_UNITS.join(', '));
    if (spec.decimals !== undefined && (spec.type !== 'decimal' || typeof spec.decimals !== 'number' || Math.floor(spec.decimals) !== spec.decimals
      || spec.decimals < 0 || spec.decimals > MAX_DECIMALS)) add('decimals só vale para type decimal, inteiro de 0 a ' + MAX_DECIMALS);
    Object.keys(spec).forEach((field) => {
      if (COLUMN_FIELDS.indexOf(field) === -1) add('campo desconhecido: ' + field);
    });
  });
  specs.forEach((spec) => {
    if (!spec || spec.exportedAs === undefined) return;
    const name = spec.key;
    if (spec.export !== false) problems.push(name + ': exportedAs só vale para coluna com export: false');
    if (!Array.isArray(spec.exportedAs) || !spec.exportedAs.length) {
      problems.push(name + ': exportedAs precisa listar as keys exportadas no lugar');
      return;
    }
    spec.exportedAs.forEach((key) => {
      const target = columnByKey(specs, key);
      if (!target) problems.push(name + ': exportedAs aponta para key inexistente ' + key);
      else if (target.export === false) problems.push(name + ': exportedAs aponta para coluna que não exporta ' + key);
    });
  });
  return problems;
};

export const uncoveredScreenColumns = (specs) => screenColumns(specs)
  .filter((spec) => spec.export === false && !(Array.isArray(spec.exportedAs) && spec.exportedAs.length))
  .map((spec) => spec.key);



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piColumns.js